import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { PROFILE_DETAILS } from '../../routes/routes';
import { ErrorToast } from '../../components';
import axios from 'axios';
import moment from 'moment';

export const termsAndConditionsSocialSign = createAsyncThunk(
  'auth/termsAndConditionsSocialSign',
  async (history: any, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;

      const token = state.auth.register?.token;

      const dateNow = moment().format();

      const { data } = await axios.put(
        `/authorization/signup/social/terms-and-conditions`,
        {
          approvalDate: dateNow,
          token
        }
      );

      history.push(PROFILE_DETAILS);

      return {
        user: data.data.user,
        token,
        approvalDate: dateNow
      };
    } catch (error: any) {
      ErrorToast(error.response.data.error);
      return rejectWithValue(error.response.data.error);
    }
  }
);
